// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination___S7HP","disabled":"Pagination_disabled__mTWAf","space":"Pagination_space__nLQXI","active":"Pagination_active__SRklh"};